export class SubscribeDTO {
    id;
    price;
    title;
    type;
    stripeId;
    stripePriceId;
    html_description;
    notificationsToUser;

  constructor(options) {
    this.id = options?.id || null;
    this.title = options?.title || "";
    this.type = options?.type || "";
    this.price = options?.price || null;
    this.stripePriceId = options?.stripePriceId || "";
    if (options?.stripeId) {
      this.stripePriceId = options?.stripeId;
    }
    this.html_description = options?.html_description || "";
    this.notificationsToUser = options?.notificationsToUser || [];
  }
}
